import { render, staticRenderFns } from "./Stopwatch.vue?vue&type=template&id=b20cc9d4&scoped=true&"
import script from "./Stopwatch.vue?vue&type=script&lang=js&"
export * from "./Stopwatch.vue?vue&type=script&lang=js&"
import style0 from "./Stopwatch.vue?vue&type=style&index=0&id=b20cc9d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20cc9d4",
  null
  
)

export default component.exports